<template>
  <div
    id="deal-details-curator-restrictions"
    class="col-12">
    <div class="row">
      <div class="col-12">
        <div class="pane-header">
          <span class="icon"><icon-colored-exchange /></span>
          <span class="text">{{ capitalize($t('names.eligibleCurators')) }}</span>
        </div>
      </div>
      <div class="col-12">
        <div class="pane-content pad-top">
          <div class="d-lg-flex flex-row justify-content-between">
            <selectable-tiles
              :items="props.selectedCuratorOrganizations"
              :should-display-images="true"
              :should-display-labels="true"
              label-property-name="name"
              image-source-property-name="logoURL"
              :is-read-only="true" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
  import { capitalize } from 'vue';

  import SelectableTiles from '@/common/components/controls/SelectableTiles.vue';
  import { IconColoredExchange } from '@/common/icons/colored';
  import CuratorOrganization from '@/common/models/misc-api-models/CuratorOrganization';

  interface IDealDetailsCuratorRestrictionsProps {
    selectedCuratorOrganizations: CuratorOrganization[];
  }
  const props = defineProps<IDealDetailsCuratorRestrictionsProps>();
</script>
